module.exports = __webpack_public_path__ + "static/media/tcfcolorlogo.eacd5258.png";